import { useCoverageStore } from '../../store/coverageStore';
import CoverageRequestDialog from './CoverageRequestDialog';

/**
 * FIX-D300-S2 (D-300 sec.2) — always mounted (Layout): a 409 CUSTOMER_NO_COVERAGE from any action opens the
 * "שליחת הודעה למנהל" dialog for that ticket. Renders nothing otherwise (and nothing at all with the switch off).
 */
export default function CoverageHost() {
  const blocked = useCoverageStore((s) => s.blocked);
  const close = useCoverageStore((s) => s.close);
  if (!blocked) return null;
  return (
    <CoverageRequestDialog
      open
      onClose={close}
      ticketId={blocked.ticket_id}
      organizationName={blocked.organization_name}
      ticketTitle={blocked.ticket_title}
      blocked
      pendingSince={blocked.request?.status === 'pending' ? blocked.request.created_at : null}
    />
  );
}
